import React from 'react';
import ClassNames from 'classnames';


import robotSuit from '../../lib/libraries/robots.js'
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';



import styles from './robot-library.css';
var time = null
class Robotlibrary extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            disablingName: ['A2'],// 禁用名单  机器人类型 如 ['C1']
            times:0,
            index:null
        }
        this.clickActive = this.clickActive.bind(this)
    }
    clickActive (disablingName,index){
        if(disablingName == -1){
            this.props.robotItemActive(index)
        }
        clearTimeout(time)
        //双击判断
        if(this.state.times == 0){
            this.setState({
                times: new Date().getTime(),
                index: index
            })
            time = setTimeout(()=>{
                this.setState({
                    times:0,
                    index:null
                })
            },200)
        }else{
            if(this.state.index === index){
                let date = new Date().getTime()
                if(date - this.state.times < 200){
                    clearTimeout(time)
                    this.props.openLibrary()
                }else{
                    this.setState({
                        times: 0,
                        index: null
                    })
                }
            }else{
                this.setState({
                    times: 0,
                    index: null
                })
            }
        }

    }
    render(){

        const {
            CloseLibrary,
            openLibrary,
            robotItemActive,
            robotActive,
            intl,
            ...componentProps
        } = this.props

        const robots = robotSuit(intl.formatMessage)
        
        return (
            <div
                    id="robotBg"
                    className={styles.robotBg}
                    onClick={(e)=>CloseLibrary(e)}
                >
                    <div className={styles.robotLibrary}>
                                <div className={styles.libraryTitle}>
                                <FormattedMessage
                                    defaultMessage="Choose a Robot Suit"
                                    description="Choose a Robot Suit Title"
                                    id="gui.gui.selectionRobot"
                                />
                                </div>
                                <div className={styles.robotOptions}>
                                    {robots.map((dataItem,index) => {
                                        var disablingName = this.state.disablingName.indexOf(dataItem.robotType)
                                        return (
                                            <div 
                                                className={ClassNames(styles.robotItem)}
                                                key={index}
                                            >   
                                            <div
                                                className={ClassNames(styles.robotContent,
                                                    {[styles.robotActive]:robotActive == index},
                                                    {[styles.robothover]:disablingName == -1},
                                                    {[styles.disabling]:disablingName !== -1})}
                                                onClick={() => {this.clickActive(disablingName,index)}}
                                            >
                                                <span>
                                                    <img src={robotActive == index ? dataItem.openimgurl : dataItem.imgurl} widht={'100%'} height={'100%'} alt="" draggable="false"/>
                                                </span>
                                                <div className={ClassNames(styles.robotName)} title={dataItem.name}>
                                                    {dataItem.name}
                                                </div>
                                                {disablingName !== -1 ? (<div className={ClassNames(styles.disablingbox)}>
                                                    <FormattedMessage
                                                        defaultMessage="In production..."
                                                        description="disabling"
                                                        id="gui.gui.disabling"
                                                    />
                                                </div>) : null}
                                            </div>
                                                
                                            </div>
                                        );
                                    })} 

                                </div>
                                <div className={styles.comfirmBox}>
                                    <button id="closeRobot" className={styles.btnClose}
                                        // onClick={CloseLibrary}
                                    >
                                    <FormattedMessage
                                        defaultMessage="Cancel"
                                        description="Cancel button"
                                        id="gui.gui.cancel"
                                    />
                                    </button>
                                    <button className={ClassNames(styles.btnOpen,{[styles.btnDisabled]:robotActive == null})}
                                        disabled={robotActive == null ? 'disabled' : null}
                                        onClick={openLibrary}
                                    >
                                    <FormattedMessage
                                        defaultMessage="OK"
                                        description="OK button"
                                        id="gui.gui.OK"
                                    />
                                    </button>
                                </div>
                    </div>
            </div>
        )
    }
}


export default Robotlibrary